import { EJRecordTypes } from 'src/common/enumerations/ej-record-types';
import { ButtonRestrictionType } from '../../common/enumerations/button-restriction-type';
import { UnitOfMeasureTypes } from '../../common/enumerations/unit-of-measure-type';
import { IElectronicJournalRecord } from '../../common/interfaces/states/IElectronicJournalRecord';

export const isButtonDisabled = (transactionState: {
  isTransactionActive: boolean;
  hasCustomer: boolean;
  disableButton: boolean;
  hasCashDrawer: boolean;
  hasPinpad: boolean;
  selectedItem?: IElectronicJournalRecord;
  tabName: string;
  hasProducts: boolean;
  hasCoupons?: boolean;
  saleModeFromReturnMode: boolean;
  isTBRActive?: boolean;
  isProcessingActive?: boolean;
  isTenderModeActivate?: boolean;
  ownBagEnabled?: boolean;
}): ((buttonAppliedTo: ButtonRestrictionType[]) => boolean) => (
  buttonAppliedTo: ButtonRestrictionType[],
) => {
  const {
    isTransactionActive,
    hasCashDrawer,
    hasPinpad,
    hasCustomer,
    disableButton,
    selectedItem,
    tabName,
    hasProducts,
    hasCoupons,
    saleModeFromReturnMode,
    isTBRActive,
    isProcessingActive,
    isTenderModeActivate,
    ownBagEnabled,
  } = transactionState;

  const EjQuantity = selectedItem ? selectedItem.Quantity : undefined;
  const EjType = selectedItem ? selectedItem.Type : undefined;
  const EJUnitOfMeasureType = selectedItem ? selectedItem.UnitOfMeasureCode : undefined;

  if (disableButton) {
    return true;
  }

  if (buttonAppliedTo.includes(ButtonRestrictionType.HasPinpad)) {
    return !hasPinpad;
  }

  if (buttonAppliedTo.includes(ButtonRestrictionType.SaleModeFromReturnMode) && !isTBRActive) {
    return saleModeFromReturnMode;
  }

  /* disable a sidebar button if the recall tab is active */
  if (
    buttonAppliedTo.includes(ButtonRestrictionType.NotRecall) &&
    Object.is(tabName, 'Recall Order')
  ) {
    return true;
  }

  if (buttonAppliedTo.includes(ButtonRestrictionType.All)) {
    return false;
  }

  if (
    buttonAppliedTo.includes(ButtonRestrictionType.QuantityGreaterThan1) &&
    (EjQuantity === undefined ||
      EjQuantity <= 1 ||
      (EJUnitOfMeasureType !== undefined && EJUnitOfMeasureType !== UnitOfMeasureTypes.Each))
  ) {
    return true;
  }

  if (
    buttonAppliedTo.includes(ButtonRestrictionType.TaxExemption) &&
    selectedItem?.Type === EJRecordTypes.TaxExemption
  ) {
    return true;
  }

  if (buttonAppliedTo.includes(ButtonRestrictionType.ActiveTransaction)) {
    return !isTransactionActive;
  }

  if (buttonAppliedTo.includes(ButtonRestrictionType.InactiveTransaction)) {
    return isTransactionActive;
  }

  if (buttonAppliedTo.includes(ButtonRestrictionType.HasCustomer)) {
    return !hasCustomer;
  }

  if (buttonAppliedTo.includes(ButtonRestrictionType.HasCoupons)) {
    return !hasCoupons;
  }

  if (buttonAppliedTo.includes(ButtonRestrictionType.HasActiveProductLines)) {
    return !(isTransactionActive && hasProducts);
  }

  if (buttonAppliedTo.includes(ButtonRestrictionType.NotProcessing)) {
    return isProcessingActive ?? false;
  }

  if (buttonAppliedTo.includes(ButtonRestrictionType.HasCashDrawer)) {
    return !hasCashDrawer;
  }

  if (buttonAppliedTo.includes(ButtonRestrictionType.NotTender)) {
    return !!isTenderModeActivate;
  }

  if (buttonAppliedTo.includes(ButtonRestrictionType.OwnBagEnabled)) {
    return !ownBagEnabled;
  }

  if (EjType === undefined || !buttonAppliedTo.includes(ButtonRestrictionType[EjType])) {
    return true;
  }

  if (
    buttonAppliedTo.includes(ButtonRestrictionType[EjType]) &&
    selectedItem &&
    selectedItem.Voided
  ) {
    return true;
  }

  return false;
};
